import React from "react";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { map } from "lodash";

import Grid from "@material-ui/core/Grid";

import Picture from "./Picture";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  photoContainer: {
    marginRight: "20px",
    width: "72px",
    height: "72px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${colors.veryLighPink}`,
    position: "relative",
  },
  deleteIcon: {
    cursor: "pointer",
    position: "absolute",
    bottom: "-7px",
    right: "-7px",
  },
};

const AddPictureGallery = (props) => {
  const { classes, photos, setPhotos } = props;

  const removeImage = (index) => {
    setPhotos(update(photos, { $splice: [[index, 1]] }));
  };

  return (
    <Grid item>
      <Grid container>
        {map(photos, (url, index) => (
          <Grid item key={index} className={classes.photoContainer}>
            <Picture
              url={url}
              maxHeight={70}
              style={{ maxWidth: "70px", maxHeight: "70px" }}
              alt="uploadedPicture"
              local={true}
            />
            <img
              onClick={() => removeImage(index)}
              src={images.deletePhotoIcon}
              alt="trash"
              className={classes.deleteIcon}
            />
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(AddPictureGallery);
